var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "header",
        { class: { "header--compact": !_vm.nav }, attrs: { id: "header" } },
        [
          _vm.nav
            ? _c(
                "a",
                {
                  staticClass: "hamburger hamburger--spring",
                  class: { "is-active": _vm.mobileNavOpen },
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.openNav.apply(null, arguments)
                    },
                  },
                },
                [_vm._m(0)]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "router-link",
            { attrs: { to: "/dashboard", id: "header__logo" } },
            [
              _c("img", {
                attrs: { src: "/images/logo/logo-nav.png", alt: "Logo" },
              }),
            ]
          ),
          _vm._v(" "),
          _vm.nav
            ? _c(
                "nav",
                {
                  class: { mobileNavOpen: _vm.mobileNavOpen },
                  attrs: { id: "header__nav" },
                },
                [
                  _c("ul", { staticClass: "nav nav--stacked" }, [
                    _c(
                      "li",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: { to: "/dashboard" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.resetState()
                              },
                            },
                          },
                          [_vm._v("Dashboard")]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.can("viewOpportunities")
                      ? _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: { to: "/opportunities" },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.resetState()
                                  },
                                },
                              },
                              [_vm._v("Opportunities")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.can("viewMADDs")
                      ? _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: { to: "/madds" },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.resetState()
                                  },
                                },
                              },
                              [_vm._v("MADDs")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.can("viewInsights")
                      ? _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: { to: "/documents" },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.resetState()
                                  },
                                },
                              },
                              [_vm._v("Documents")]
                            ),
                            _vm._v(" "),
                            _vm.showDocumentSubmenu
                              ? _c("ul", { staticClass: "submenu" }, [
                                  _vm.can("createInsights")
                                    ? _c(
                                        "li",
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              staticClass: "admin",
                                              attrs: {
                                                to: { name: "create-document" },
                                              },
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.resetState()
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                - Add Document\n                            "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.can("createInsightCategories")
                                    ? _c(
                                        "li",
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              staticClass: "admin",
                                              attrs: {
                                                to: {
                                                  name: "create-document-category",
                                                },
                                              },
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.resetState()
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                - Add Category\n                            "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.can("deleteInsightCategories")
                                    ? _c(
                                        "li",
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              staticClass: "admin",
                                              attrs: {
                                                to: {
                                                  name: "delete-document-categories",
                                                },
                                              },
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.resetState()
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                - Delete Category\n                            "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ])
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.can("viewSectors")
                      ? _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: { to: "/sectors" },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.resetState()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        Sectors\n                        "
                                ),
                                _vm.notificationCount > 0
                                  ? _c("span", {
                                      staticClass: "notification-count",
                                      domProps: {
                                        textContent: _vm._s(
                                          `+${_vm.notificationCount}`
                                        ),
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.can("viewMembers")
                      ? _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: { to: "/members" },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.resetState()
                                  },
                                },
                              },
                              [_vm._v("Members")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.can("viewUsers")
                      ? _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "admin",
                                attrs: { to: "/users" },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.resetState()
                                  },
                                },
                              },
                              [_vm._v("- Users")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.can("viewUsers")
                      ? _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "admin",
                                attrs: { to: "/reports" },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.resetState()
                                  },
                                },
                              },
                              [_vm._v("- Reports")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.can("impersonateUsers") && !_vm.impersonating
                      ? _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "admin",
                                attrs: { to: "/assume-identity" },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.resetState()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        - Assume Identity\n                    "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm.impersonating
                      ? _c("li", [
                          _c(
                            "a",
                            {
                              staticClass: "admin",
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.leaveImpersonation(_vm.event)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$wait.is("leaveImpersonation")
                                      ? "Reverting..."
                                      : "- Revert Identity"
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "li",
                      [
                        _c(
                          "router-link",
                          {
                            attrs: { to: "/search" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.resetState()
                              },
                            },
                          },
                          [_vm._v("Search")]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.can("viewEvents")
                      ? _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: { to: "/events" },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.resetState()
                                  },
                                },
                              },
                              [_vm._v("Events")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.event
                      ? _c(
                          "li",
                          {
                            staticClass: "c-event-link",
                            attrs: { id: "header__event" },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "c-event-link__content" },
                              [
                                _c(
                                  "h2",
                                  { staticClass: "c-event-link__header" },
                                  [_vm._v(_vm._s(_vm.event.eventName))]
                                ),
                                _vm._v(" "),
                                _c("p", { staticClass: "c-event-link__copy" }, [
                                  _vm._v(_vm._s(_vm.event.timeRange)),
                                ]),
                                _vm._v(" "),
                                this.$store.getters.registrationCompleted
                                  ? _c(
                                      "p",
                                      { staticClass: "c-event-link__copy" },
                                      [
                                        _vm._v(
                                          "\n                            Thanks for registering\n                        "
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "router-link",
                                      {
                                        staticClass:
                                          "btn btn--primary c-event-link__btn",
                                        attrs: { to: "/register/event" },
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.resetState()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                            Sign up\n                        "
                                        ),
                                      ]
                                    ),
                              ],
                              1
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "li",
                      { attrs: { id: "header__account" } },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: { to: "/account" },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.resetState()
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: `/images/avatar/${_vm.user.id}`,
                                alt: "",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("My Account")]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { id: "header__secondary" } },
            [
              _c(
                "div",
                { attrs: { id: "header__search" } },
                [
                  _c("HeaderSearch", {
                    attrs: {
                      typeahead: true,
                      "default-value": _vm.$route.params.query,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("Notifications", {
                attrs: { count: _vm.notificationCount },
                on: { updated: _vm.getNotificationCount },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "main",
        {
          ref: "main-content",
          class: { container: true, "has-fixed-group": _vm.hasFixedGroup },
          attrs: { id: "content" },
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c("v-dialog"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "hamburger-box" }, [
      _c("div", { staticClass: "hamburger-inner" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }